import { Injectable } from "@angular/core";
import { CreationRequest, CreationResponse } from "@fiduciaria/RequestCreation/Types/Interfaces/new-request-creation.interface";
import { Observable } from "rxjs";

import { UsuariosRepository } from "@shared/Repositories/usuarios.repository";

import { CanalesUserFiduciaryRepository } from "../../../Canales/UserFiduciary/Shared/Repository/canales-user-fiduciary.repository";
import { TrustRepository } from "../Repositories/trust.repository";
import { BizagiOption, RequestStatus, Currency, IdentificationType } from "../Types/bizagi-option.interface";
import { Dependency } from "../Types/dependency.interface";
import { AdditionalField, Escrow } from "../Types/escrow.interface";
import { TrustRequest } from "../Types/request.interface";
import { TrustRequestsFilter } from "../Types/requests-filter.interface";
import { RequiredDocument, RequiredDocumentsFilter } from "../Types/required-document.interface";
import { RequiredInfo } from "../Types/required-info.interface";
import { TrustSubType, TrustType } from "../Types/type.interface";

@Injectable()
export class TrustService {
  constructor(
    private readonly fiduciariaRepository: TrustRepository,
    private readonly userService: UsuariosRepository,
    private readonly fiduciaryAdministracionRepository: CanalesUserFiduciaryRepository
  ) {}

  public getEscrows(): Observable<Escrow[]> {
    return this.fiduciariaRepository.getEscrows();
  }

  public getEscrowsAll(): Observable<Escrow[]> {
    return this.fiduciariaRepository.getEscrowsAll();
  }

  public getDependencies(): Observable<Dependency[]> {
    return this.fiduciariaRepository.getDependencies();
  }

  public getUserFideicomisos(): Observable<Escrow[]> {
    return this.fiduciaryAdministracionRepository.getUserFideicomisos();
  }

  public getAreasByIdFideicomiso(idFideicomiso: number): Observable<Dependency[]> {
    return this.fiduciaryAdministracionRepository.getAreasByIdFideicomiso(idFideicomiso);
  }

  public getTypes(dependencyId: string): Observable<TrustType[]> {
    return this.fiduciariaRepository.getTypes(dependencyId);
  }

  public getSubTypes(typeId: string): Observable<TrustSubType[]> {
    return this.fiduciariaRepository.getSubTypes(typeId);
  }

  public getRequestStatus(): Observable<RequestStatus[]> {
    return this.fiduciariaRepository.getRequestStatus();
  }

  public getRequiredDocuments(filter: RequiredDocumentsFilter): Observable<RequiredDocument[]> {
    return this.fiduciariaRepository.getRequiredDocuments(filter);
  }

  public getRequiredInfo(subTypeId: string): Observable<RequiredInfo> {
    return this.fiduciariaRepository.getRequiredInfo(subTypeId);
  }

  public getStages(): Observable<BizagiOption[]> {
    return this.fiduciariaRepository.getStages();
  }

  public getAdditionalRequiredFields(subTypeId: string): Observable<AdditionalField[]> {
    return this.fiduciariaRepository.getAdditionalRequiredFields(subTypeId);
  }

  public getCurrencies(): Observable<Currency[]> {
    return this.fiduciariaRepository.getCurrencies();
  }

  public createTrustRequest(creationRequest: CreationRequest): Observable<CreationResponse> {
    return this.fiduciariaRepository.createTrustRequest(creationRequest);
  }

  public getTrustRequests(filter: TrustRequestsFilter): Observable<TrustRequest[]> {
    return this.fiduciariaRepository.getTrustRequests(filter);
  }

  public getTrustApplicationsByUserEscrowsRequests(filter: TrustRequestsFilter): Observable<TrustRequest[]> {
    return this.fiduciariaRepository.getTrustApplicationsByUserEscrowsRequests(filter);
  }

  public getTrustRequestsAlways(filter: TrustRequestsFilter): Observable<TrustRequest[]> {
    return this.fiduciariaRepository.getTrustRequestsAlways(filter);
  }

  public getIdentificationTypes(): Observable<IdentificationType[]> {
    return this.fiduciariaRepository.getIdentificationTypes();
  }

  public getCustomerTypes(): Observable<BizagiOption[]> {
    return this.fiduciariaRepository.getCustomerTypes();
  }
}
